<template>
    <div class="wrapper">
        <Header/>
        <Login/>
        <Register/>
        <RegisterEmail/>
        <ForgotPassword/>
        <ForgotAccount/>
        <Member/>
        <ChangeEmail/>
        <ChangePassword/>
        <EmailLogin/>
        <ShowMsgModal/>
        <router-view :key="key"/>
        <Footer/>
    </div>
    <!--
    <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div>
    <router-view/>
    -->
</template>

<script>
// @ is an alias to /src
import $ from "jquery";
import axios from "axios";

// components
import Footer from "@/components/Footer.vue";
import Header from "@/components/Header.vue";

// components/modal
import ChangeEmail from "@/components/modal/ChangeEmail.vue";
import ChangePassword from "@/components/modal/ChangePassword.vue";
import EmailLogin from "@/components/modal/EmailLogin.vue";
import ForgotAccount from "@/components/modal/ForgotAccount.vue";
import ForgotPassword from "@/components/modal/ForgotPassword.vue";
import Login from "@/components/modal/Login.vue";
import Member from "@/components/modal/Member.vue";
import Register from "@/components/modal/Register.vue";
import RegisterEmail from "@/components/modal/RegisterEmail.vue";
import ShowMsgModal from "@/components/modal/ShowMsgModal.vue";

// util
import RecaptchaUtil from "@/assets/js/util/RecaptchaUtil.js";

// init modal
import * as cmModal from "@/assets/js/cm-modal.js";

export default {
    name: "home",
    computed: {
        key() {
            this.$route
            return new Date().getTime() + ""
        }
    },
    components: {
        // components
        Footer,
        Header,

        // components/modal
        ChangeEmail,
        ChangePassword,
        EmailLogin,
        ForgotAccount,
        ForgotPassword,
        Login,
        Member,
        Register,
        RegisterEmail,
        ShowMsgModal
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            // 外部ip轉至正式機
            if(location.hostname != "www.all9fun.com") {
                let redirectFlag = false; // 判斷是否轉正式機
                const response = await axios({
                    method: "get",
                    url: process.env.VUE_APP_URL_DOMAIN_LOGIN + "/check_internal_ip.jsp", // 內部ip回傳true
                    timeout: process.env.VUE_APP_AJAX_TIME_OUT_MILLISECOND,
                    config: { headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }}
                }).catch(function() {
                    redirectFlag = true;
                });

                if(response==undefined || response.data === false) {
                    redirectFlag = true;
                }
                
                if(redirectFlag) {
                    location.href = "//www.all9fun.com";
                    return;
                }
            }
            cmModal.init();
            RecaptchaUtil.initGoogleRecaptcha();
        }
    }
};
</script>

<style>
#app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
}
</style>
